import { render } from "./SurveyQuestion10.vue?vue&type=template&id=ba848538"
import script from "./SurveyQuestion10.vue?vue&type=script&lang=js"
export * from "./SurveyQuestion10.vue?vue&type=script&lang=js"

import "./SurveyQuestion10.vue?vue&type=style&index=0&id=ba848538&lang=css"

import exportComponent from "/home/danujaf/development/customer-survey/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__